// extracted by mini-css-extract-plugin
export default {"addresssLayerBox":"AddAddressPopup_addresssLayerBox__0G1eL","addressContainer":"AddAddressPopup_addressContainer__agUSk","closeLogin":"AddAddressPopup_closeLogin__bYPQ8"};